import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/Notus_logo.png'


_pushScopeId("data-v-31a2787e")
const _hoisted_1 = { class: "summary-footer color-primary fs-14 lh-21" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-md-6 d-flex d-md-block justify-content-between align-items-top mb-3 mb-md-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "summary-footer_logo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://notus.pl/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "{{ $t('general.header.logo.alt')  }}",
      class: "logo",
      width: "140",
      height: "38"
    })
  ])
], -1)
const _hoisted_5 = { class: "summary-footer_social my-md-3" }
const _hoisted_6 = ["href", "aria-label"]
const _hoisted_7 = ["href", "aria-label"]
const _hoisted_8 = ["href", "aria-label"]
const _hoisted_9 = { class: "d-none d-md-block" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "d-block d-md-none mt-3" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notus_svg_icon = _resolveComponent("notus-svg-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: _ctx.socialLinks.facebook,
            target: "_blank",
            "aria-label": _ctx.$t('page.summary.section.footer.social.facebookTitle'),
            class: "social-icon"
          }, [
            _createVNode(_component_notus_svg_icon, { iconType: "facebook" })
          ], 8, _hoisted_6),
          _createElementVNode("a", {
            href: _ctx.socialLinks.youtube,
            target: "_blank",
            "aria-label": _ctx.$t('page.summary.section.footer.social.youtubeTitle'),
            class: "social-icon"
          }, [
            _createVNode(_component_notus_svg_icon, { iconType: "youtube" })
          ], 8, _hoisted_7),
          _createElementVNode("a", {
            href: _ctx.socialLinks.linkedin,
            target: "_blank",
            "aria-label": _ctx.$t('page.summary.section.footer.social.linkedinTitle'),
            class: "social-icon"
          }, [
            _createVNode(_component_notus_svg_icon, { iconType: "linkedin" })
          ], 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('page.summary.section.footer.copyright', { year: _ctx.currentYear } )), 1)
      ]),
      _createElementVNode("div", {
        class: "col-12 col-md-6",
        innerHTML: _ctx.$t('page.summary.section.footer.disclaimer')
      }, null, 8, _hoisted_10),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('page.summary.section.footer.copyright', { year: _ctx.currentYear } )), 1)
    ])
  ]))
}